import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("connect@christiancovenantnetwork.us");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen pt-32 pb-20 flex items-center">
      <div className="ccn-container max-w-md">
        <div className="ccn-card p-10">
          <div className="w-14 h-14 rounded-full bg-[#C8664D]/10 text-[#C8664D] flex items-center justify-center mb-6">
            <Lock className="w-6 h-6" />
          </div>
          <h1 className="ccn-h2 mb-2">Admin sign in</h1>
          <p className="text-sm text-[#575A58] mb-8">Manage sermons, live stream, subscribers and giving.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm text-[#575A58]">Email</label>
              <input
                type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
                className="mt-2 w-full px-5 py-3 rounded-full bg-white border border-[#2A2E2C]/10 focus:outline-none focus:border-[#C8664D]"
              />
            </div>
            <div>
              <label className="text-sm text-[#575A58]">Password</label>
              <input
                type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="mt-2 w-full px-5 py-3 rounded-full bg-white border border-[#2A2E2C]/10 focus:outline-none focus:border-[#C8664D]"
              />
            </div>
            {err && <div data-testid="admin-login-error" className="text-sm text-red-600">{err}</div>}
            <button type="submit" disabled={loading} data-testid="admin-login-submit" className="ccn-btn-primary w-full justify-center">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
